import { Card, Typography, 
            // useTheme 
      } from '@mui/material';
import { Box } from '@mui/system';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import React from 'react';
// LOCAL
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

/**
 * 
 * @param {String} title PieChart's title
 * @param {Object} data format --> { label: value, label: value }
 * @returns 
 */
function LabelPieChart({ title, data, label1, label2 }) {
      // const theme = useTheme();

      // yelow, green, red,
      // const backgroundColor = ['#ffff80', '#80ff80', '#ff6666']
      const options = {
            responsive: true,
            plugins: {
                  legend: { position: 'none' },
            }
      }

      function getTotal(initData) {
            let total = 0;
            Object.entries(initData).map((d) => { total += d[1] })
            return total
      }

      function generateData(initData) {
            let label = [];
            let data = [];
            let backgroundColor = [];

            Object.entries(initData).map((d) => {
                  label.push(d[0]) // lable
                  data.push(d[1]) // values

                  // Assign background color based on status
                  switch (d[0]) {
                        case 'active':
                        backgroundColor.push('#74B569'); // green
                        break;
                        case 'inactive':
                        backgroundColor.push('#B56969'); // red
                        break;
                        case 'draft':
                        backgroundColor.push('#BDBABB'); // gray
                        break;
                        case 'verifying':
                        case 'unverified':
                        backgroundColor.push('#F4CC64'); // yellow
                        break;
                        default:
                        backgroundColor.push('#000000'); // fallback color
                  }
            })

            const _data = {
                  labels: label,
                  datasets: [
                        {
                              data: data,
                              backgroundColor: backgroundColor,
                              borderWidth: 0,
                        },
                  ],
            };

            return _data
      }


      return (
            <Card sx={{ display: 'flex', flexDirection: 'row', width: '100%', height: 230, p: 4 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <Typography variant='caption'>{title}</Typography>
                        <Typography sx={{ fontSize: '20px', color: "blue", fontWeight: 600, marginTop: "8px", marginBottom: "0px" }}>{label1}</Typography>
                        <Typography sx={{ fontSize: '18px', fontWeight: 600, marginTop: "4px" }}>{label2}</Typography>
                        
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '150px' }}>
                        {
                              getTotal(data) > 0
                                    ? <Doughnut options={options} data={generateData(data)} />
                                    : <Box sx={{ background: '#E9E9E9', width: 118, height: 118, borderRadius: 100 }} />
                        }
                  </Box>
            </Card>
      );
}

export default LabelPieChart; 